import { Button, Checkbox, DialogActions, DialogTitle, IconButton } from "@mui/material";
import usePortfolio from "../../hooks/PortfolioProvider";
import { IAccountClient } from "../../models/Portfolio";
import { DeleteOutline } from "@mui/icons-material";
import { useDialog } from "../../libs/dialog/DialogProvider";
import EditAccount from "./EditAccount";

function AccountRow(props:{account:IAccountClient}) {
    return <div className="account row middle gap-8">
        <div className="name">{props.account.name}</div>
        <IconButton size="small"><DeleteOutline/></IconButton>
    </div>
}

export default function ManageAccounts(){
    const {portfolio} = usePortfolio()
    const {openDialog, closeDialog} = useDialog()
    const accounts = portfolio.accounts.map(a => <AccountRow account={a} key={a.id}/>)
    
    const onAdd = () => {
        closeDialog()
        setTimeout(() => openDialog({id:"editAccount", children:<EditAccount account={-1}/>}),500)
    }
    return <>
        <DialogTitle>Accounts</DialogTitle>
        <div className="content">
            <div className="manageAccounts">
                {accounts}
            </div>
        </div>
        <DialogActions>
            <Button onClick={onAdd}>Add</Button>
        </DialogActions>
    </>
}